import React from 'react'
import { Box, Typography } from '@mui/material'
import update from 'immutability-helper'
import { promptTeamName } from '../../lib/dialog'
import { sendWs, TEAMS } from '../../lib/send'
import store from '../../redux/store'
import './TeamName.scss'

const TeamName = ({ team, teamIndex }) => {
  const inputTeamName = () => {
    promptTeamName(team.name, changeTeamName)
  }

  const changeTeamName = text => {
    const { teams } = store.getState()
    const newTeams = update(teams.disp, {
      [teamIndex]: {
        name: { $set: text }
      }
    })
    sendWs(TEAMS, newTeams)
  }

  return (
    <Box className="team-name" onClick={inputTeamName}>
      <Typography align="center">
        {team.name}
      </Typography>
    </Box>
  )
}

export default TeamName
